<template>
  <v-dialog v-model="open" width="580px" scrollable>
    <v-card dense>
      <v-toolbar elevation="0">
        <v-toolbar-title
          style="padding-left: 10px"
          class="titleText newTitle--text"
        >
          {{ $t('message.pages.credits.creditsPaymentModal.title') }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="handleClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text
        :class="isMobileBreakpoint ? 'py-0' : 'px-7 py-0'"
        style="max-height: 450px"
      >
        <v-col class="pa-0" cols="12" v-if="errors.fetchError">
          <v-row no-gutters align="center">
            <v-alert dense outlined type="error" width="100%">
              <span class="footerText align-text d-block">
                {{ errors.shownErrMsg }}
                <v-tooltip top v-if="errors.tooltipErrMsg">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="pb-1" size="18" v-bind="attrs" v-on="on">
                      mdi-help-circle
                    </v-icon>
                  </template>
                  <v-container
                    class="text-body-2 pa-0"
                    style="max-width: 230px"
                  >
                    {{ errors.tooltipErrMsg }}
                  </v-container>
                </v-tooltip>
              </span>
            </v-alert>
          </v-row>
        </v-col>
        <v-row
          v-if="(pendingPayment || paymentDone) && !loadings.brazilPayments"
          no-gutters
        >
          <v-col cols="12">
            <v-row
              class="flex-column"
              :class="isMobileBreakpoint ? '' : 'px-11'"
              no-gutters
              align="center"
              justify="center"
            >
              <v-icon size="64" color="#C8E6C9">mdi-check-circle</v-icon>
              <span class="paymentText textType2--text">{{
                $t('message.pages.credits.creditsPaymentModal.boughtCredits')
              }}</span>
              <span class="dateText textType--text"
                >Em {{ formattedTime }}</span
              >
              <span
                class="paymentCodeText textType2--text mt-5"
                :class="isMobileBreakpoint ? 'mb-2' : ''"
              >
                {{
                  payment.type === 'pix'
                    ? $t('message.pages.credits.creditsPaymentModal.qrcodeText')
                    : payment.type === 'boleto'
                    ? $t('message.pages.credits.creditsPaymentModal.boletoText')
                    : $t('message.pages.credits.creditsPaymentModal.cardText')
                }}
              </span>
              <v-col
                v-if="!loadings.brazilPayments"
                cols="12"
                class="d-flex flex-row align-center justify-center"
              >
                <img
                  style="height: 175px"
                  v-if="payment.type === 'pix'"
                  :src="qrCodeSource"
                />
                <v-btn
                  v-if="payment.type === 'boleto'"
                  class="mt-5"
                  small
                  elevation-0
                  color="primary"
                  @click="handleOpenBoletoPdf"
                  >{{
                    $t('message.pages.credits.creditsPaymentModal.seeBoleto')
                  }}</v-btn
                >
              </v-col>
              <v-col
                cols="12"
                v-if="payment.type !== 'card' && !loadings.brazilPayments"
              >
                <v-textarea
                  v-model="paymentText"
                  outlined
                  class="wrapText mt-4"
                  hide-details
                  dense
                  no-resize
                  color="primary"
                  readonly
                  style="font-size: 14px"
                  rows="3"
                />
              </v-col>
              <span
                v-if="payment.type !== 'card' && !loadings.brazilPayments"
                class="mt-1 primary--text"
                @click="handleCopyPaymentCode"
                style="cursor: pointer"
              >
                <v-icon size="16" color="primary">mdi-content-copy</v-icon>
                {{ $t('message.pages.credits.creditsPaymentModal.copyCode') }}
              </span>
              <v-col cols="12" class="mt-6">
                <v-row no-gutters justify="space-between">
                  <span>{{
                    $t(
                      'message.pages.credits.creditsPaymentModal.boughtCredits'
                    )
                  }}</span>
                  <v-col
                    class="d-flex flex-row align-center justify-center shrink"
                  >
                    <v-img
                      height="18px"
                      width="18px"
                      src="../../../assets/credit_grey_icon.svg"
                    />
                    <span
                      >{{
                        Math.floor(creditValue).toLocaleString(currencyLocale, {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        })
                      }}
                    </span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="my-3">
                <v-divider />
              </v-col>
              <v-col cols="12">
                <v-row no-gutters justify="space-between">
                  <span>{{ $t('message.value') }}</span>
                  <span>{{
                    Number(formattedCreditValue).toLocaleString(
                      currencyLocale,
                      {
                        style: 'currency',
                        currency: currency,
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )
                  }}</span>
                </v-row>
              </v-col>
              <v-col cols="12" class="my-3">
                <v-divider />
              </v-col>
              <v-col cols="12">
                <v-row no-gutters justify="space-between">
                  <span>{{
                    $t('message.pages.credits.creditsPaymentModal.paymentForm')
                  }}</span>
                  <span>{{
                    payment.type === 'card'
                      ? 'Cartão'
                      : payment.type === 'boleto'
                      ? 'Boleto'
                      : 'PIX'
                  }}</span>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-else no-gutters>
          <v-col cols="12" class="mb-2">
            <span>{{
              $t('message.pages.credits.creditsPaymentModal.selectQuantity')
            }}</span>
          </v-col>
          <v-col cols="12">
            <v-row no-gutters>
              <v-col cols="12">
                <v-row no-gutters justify="space-between">
                  <v-col cols="4" class="pr-3">
                    <v-card
                      class="d-flex flex-column align-center"
                      width="100%"
                      flat
                      height="108px"
                      style="cursor: pointer"
                      :style="
                        selectedCard === 1
                          ? 'border: 2px solid #3f55ee'
                          : 'border: 1px solid #C2C6E7'
                      "
                      @click="handleFirstCard"
                    >
                      <div
                        class="d-flex flex-row align-center justify-center"
                        style="margin-top: 28px; margin-bottom: 20px"
                      >
                        <v-img
                          v-if="selectedCard === 1"
                          src="../../../assets/credit_blue_icon.svg"
                        />
                        <v-img
                          v-else
                          height="24px"
                          width="24px"
                          src="../../../assets/credit_grey_icon.svg"
                        />
                        <span
                          class="pl-1 mainText"
                          :class="
                            selectedCard === 1
                              ? 'primary--text'
                              : 'textType--text'
                          "
                          >{{ optionsValues[0] }}
                        </span>
                      </div>
                      <span
                        class="priceText"
                        :class="
                          selectedCard === 1
                            ? 'primary--text'
                            : 'textType--text'
                        "
                        >{{
                          optionsValues[0].toLocaleString(currencyLocale, {
                            style: 'currency',
                            currency: currency,
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}</span
                      >
                    </v-card>
                  </v-col>
                  <v-col cols="4" class="pr-3">
                    <v-card
                      class="d-flex flex-column align-center"
                      width="100%"
                      flat
                      height="108px"
                      style="cursor: pointer"
                      :style="
                        selectedCard === 2
                          ? 'border: 2px solid #3f55ee'
                          : 'border: 1px solid #C2C6E7'
                      "
                      @click="handleSecondCard"
                    >
                      <div
                        class="d-flex flex-row align-center justify-center"
                        style="margin-top: 28px; margin-bottom: 20px"
                      >
                        <v-img
                          v-if="selectedCard === 2"
                          src="../../../assets/credit_blue_icon.svg"
                        />
                        <v-img
                          v-else
                          height="24px"
                          width="24px"
                          src="../../../assets/credit_grey_icon.svg"
                        />
                        <span
                          class="pl-1 mainText"
                          :class="
                            selectedCard === 2
                              ? 'primary--text'
                              : 'textType--text'
                          "
                          >{{ optionsValues[1] }}</span
                        >
                      </div>
                      <span
                        class="priceText"
                        :class="
                          selectedCard === 2
                            ? 'primary--text'
                            : 'textType--text'
                        "
                      >
                        {{
                          optionsValues[1].toLocaleString(currencyLocale, {
                            style: 'currency',
                            currency: currency,
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }}
                      </span>
                    </v-card>
                  </v-col>
                  <v-col cols="4">
                    <v-card
                      class="d-flex flex-column align-center"
                      width="100%"
                      flat
                      height="108px"
                      :style="
                        selectedCard === 3
                          ? 'border: 2px solid #3f55ee'
                          : 'border: 1px solid #C2C6E7'
                      "
                      style="cursor: default !important"
                      @click="selectedCard = 3"
                    >
                      <span class="mt-3 mb-1 textType--text pr-2 otherText">{{
                        $t(
                          'message.pages.credits.creditsPaymentModal.otherValue'
                        )
                      }}</span>
                      <div class="d-flex flex-row align-center justify-center">
                        <v-text-field
                          v-model="creditValue"
                          class="quantityTextField"
                          type="number"
                          min="0"
                          max="10000"
                          style="max-width: 120px"
                          outlined
                          placeholder="100"
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                      <span
                        class="priceText"
                        :class="
                          selectedCard === 3
                            ? 'primary--text'
                            : 'textType--text'
                        "
                      >
                        {{
                          Number(formattedCreditValue).toLocaleString(
                            currencyLocale,
                            {
                              style: 'currency',
                              currency: currency,
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )
                        }}
                      </span>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="mt-4">
                <v-card
                  width="100%"
                  color="newBackground"
                  flat
                  class="px-4 pb-2"
                >
                  <v-row no-gutters>
                    <v-col cols="12" class="mt-6 mb-4">
                      <span class="paymentText textType--text">{{
                        $t(
                          'message.pages.credits.creditsPaymentModal.paymentForm'
                        )
                      }}</span>
                    </v-col>
                    <v-col cols="12">
                      <v-card
                        v-if="currency === 'brl'"
                        width="100%"
                        flat
                        style="border: 1px solid #3f55ee"
                      >
                        <v-row no-gutters>
                          <v-col cols="4">
                            <v-btn
                              class="px-0"
                              block
                              :plain="payment.type != 'card'"
                              tile
                              style="border-right: 1px solid grey"
                              :color="payment.type === 'card' ? 'primary' : ''"
                              @click="handleChangePaymentType('card')"
                            >
                              <span class="optionsText">{{
                                $t(
                                  'message.pages.credits.creditsPaymentModal.creditCard'
                                )
                              }}</span>
                            </v-btn>
                          </v-col>
                          <v-col cols="4">
                            <v-btn
                              class="px-0"
                              block
                              :plain="payment.type != 'pix'"
                              tile
                              style="border-right: 1px solid grey"
                              :color="payment.type === 'pix' ? 'primary' : ''"
                              @click="handleChangePaymentType('pix')"
                            >
                              <span
                                class="optionsText"
                                style="text-transform: capitalize"
                                >PIX</span
                              >
                            </v-btn>
                          </v-col>
                          <v-col cols="4">
                            <v-btn
                              class="px-0"
                              block
                              :plain="payment.type != 'boleto'"
                              tile
                              :color="
                                payment.type === 'boleto' ? 'primary' : ''
                              "
                              @click="handleChangePaymentType('boleto')"
                            >
                              <span class="optionsText">Boleto</span>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                    <v-col
                      v-if="payment.type === 'card'"
                      cols="12"
                      class="mb-4"
                    >
                      <v-row
                        no-gutters
                        class="flex-column align-center justify-center"
                      >
                        <v-col
                          v-if="!userCards.length"
                          cols="12"
                          class="d-flex flex-row align-center justify-center mt-8"
                        >
                          <v-progress-circular
                            :size="32"
                            width="3"
                            color="primary"
                            indeterminate
                          ></v-progress-circular>
                        </v-col>
                        <v-col :cols="isMobileBreakpoint ? '12' : '8'" v-else>
                          <v-radio-group v-model="radioCardValue" hide-details>
                            <v-radio
                              v-for="card in userCards"
                              :key="card.id"
                              :value="card.id"
                            >
                              <template v-slot:label>
                                <v-row no-gutters v-if="card.type === 'card'">
                                  <v-card
                                    color="newBackground"
                                    width="100%"
                                    flat
                                    class="d-flex flex-row align-center justify-space-between"
                                  >
                                    <v-row no-gutters>
                                      <img
                                        v-if="!isMobileBreakpoint"
                                        :src="
                                          cardsImages[
                                            `${card.brand.toLowerCase()}`
                                          ]
                                        "
                                        width="38"
                                        class="rounded card-image"
                                      />
                                      <span
                                        class="cardText textType2--text pl-2"
                                        style="padding-top: 2px"
                                      >
                                        Cartão de crédito
                                        {{
                                          capitalizeFirstLetter(card.brand)
                                        }}-{{ card.last4 }}
                                      </span>
                                    </v-row>
                                  </v-card>
                                </v-row>
                                <v-row v-else no-gutters>
                                  <span class="cardText textType2--text">
                                    {{
                                      $t(
                                        'message.pages.credits.creditsPaymentModal.newCard'
                                      )
                                    }}
                                  </span>
                                </v-row>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col v-if="radioCardValue === 'newCard'" cols="8">
                          <v-row no-gutters>
                            <v-col cols="12" class="mt-1">
                              <span class="fieldText textType--text">{{
                                $t('message.pages.paymentModal.cardNumber')
                              }}</span>
                            </v-col>
                            <v-col cols="12" class="mt-1">
                              <stripe-element-card
                                key="creditStripeCard"
                                id="creditStripeCard"
                                ref="creditStripeCard"
                                :hidePostalCode="true"
                                :pk="stripeKeyByCountry"
                                @token="handleToken"
                                @keydown.enter="() => {}"
                              />
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col v-else cols="12" class="mb-4"></v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <span v-if="!pendingPayment && !paymentDone" class="ml-7">
        <small>
          {{ $t('message.pages.credits.creditsPaymentModal.nonRefundable') }}
        </small>
      </span>
      <v-card-actions
        class="d-flex flex-row align-center justify-center px-7 pb-5 pt-7"
      >
        <v-spacer v-if="!pendingPayment && !paymentDone"></v-spacer>
        <v-btn
          v-if="(pendingPayment || paymentDone) && !loadings.brazilPayments"
          class="elevation-0"
          color="primary"
          @click="handleCreditsHistory"
        >
          <span class="px-5">{{
            $t('message.pages.credits.creditsPaymentModal.creditsHistory')
          }}</span>
        </v-btn>
        <v-btn
          v-else
          class="elevation-0"
          color="primary"
          :disabled="loadings.saveCredits"
          :loading="loadings.saveCredits"
          @click="handleAddCredit"
        >
          <span class="px-5">{{
            $t('message.pages.credits.creditsPaymentModal.buyCredits')
          }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import planApi from '@/services/planApi'
import creditsApi from '@/services/creditsApi'
import i18n from '@/translations/lang'
import { StripeElementCard } from '@vue-stripe/vue-stripe'

export default {
  name: 'CreditsPaymentModal',
  components: {
    StripeElementCard,
  },
  data: () => ({
    optionsValues: [20, 50],
    open: false,
    loadings: {
      saveCredits: false,
      getCardsLoading: false,
      brazilPayments: false,
    },
    creditValue: 20,
    payment: {
      type: 'card',
    },
    selectedCard: 1,
    userCards: [],
    defaultSource: null,
    cardsImages: {
      mastercard:
        'https://js.stripe.com/v3/fingerprinted/img/mastercard-4d8844094130711885b5e41b28c9848f.svg',
      visa: 'https://js.stripe.com/v3/fingerprinted/img/visa-729c05c240c4bdb47b03ac81d9945bfe.svg',
      elo: 'https://js.stripe.com/v3/fingerprinted/img/elo-efe873e884e6c9eb817f23a120caaa3e.svg',
      american_express:
        'https://js.stripe.com/v3/fingerprinted/img/elo-efe873e884e6c9eb817f23a120caaa3e.svg',
    },
    radioCardValue: null,
    currencyLocale: 'pt-BR',
    stripeKey: process.env.VUE_APP_STRIPE_API,
    stripeKeyUS: process.env.VUE_APP_STRIPE_API_US,
    pendingPayment: false,
    paymentDone: false,
    qrCodeSource: '',
    paymentText: '',
    boletoPdfUrl: '',
    errors: {
      fetchData: false,
      fetchError: false,
      shownErrMsg: 'Error',
      tooltipErrMsg: 'Error',
    },
    cardErrors: {
      declined: false,
      default: false,
      expired: false,
    },
    formattedTime: '',
  }),
  computed: {
    ...mapState({
      userPlanInfo: (state) => state.user.userPlanInfo,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    currency() {
      return this.userPlanInfo.currency ?? 'brl'
    },
    stripeKeyByCountry() {
      if (this.userPlanInfo?.currency === 'brl') return this.stripeKey
      return this.stripeKeyUS
    },
    formattedCreditValue() {
      let amount = this.creditValue
      if (amount >= 1000 && amount < 5000) {
        // apply 10% discount
        amount = amount * 0.9
      } else if (amount >= 5000) {
        // apply 15% discount
        amount = amount * 0.85
      }
      return amount
    },
  },
  mounted() {
    this.$root.$on('creditsPaymentModal', () => {
      this.getCards()
      Object.assign(this.$data, this.initialState())
      this.setCurrencyConfig()
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('creditsPaymentModal')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    ...mapActions('session', ['signInUser', 'fetchSession']),
    setCurrencyConfig() {
      if (this.currency === 'usd') {
        this.currencyLocale = 'en-US'
        return
      } else {
        this.currencyLocale = 'pt-BR'
      }
    },
    handleFirstCard() {
      this.selectedCard = 1
      this.creditValue = this.optionsValues[0]
    },
    handleSecondCard() {
      this.selectedCard = 2
      this.creditValue = this.optionsValues[1]
    },
    async getCards() {
      this.loadings.getCardsLoading = true
      try {
        const { data } = await planApi.getCards()
        this.userCards = data.sources.filter((source) => source.type === 'card')
        this.userCards.push({ id: 'newCard' })
        const card = data.sources.find((item) => item.default === true)
        if (card.type === 'card') {
          this.defaultSource = card
          this.radioCardValue = card.id
        }
        this.loadings.getCardsLoading = false
      } catch (error) {
        this.loadings.getCardsLoading = false
        console.error('error', error)
      }
    },
    handleValidations() {
      if (this.creditValue < 5) {
        this.errors.fetchError = true
        this.errors.shownErrMsg =
          'O valor inserido é abaixo do valor de R$ 5,00 permitido'
        return false
      }
      if (this.creditValue > 15000) {
        this.errors.fetchError = true
        this.errors.shownErrMsg =
          'O valor inserido é acima do valor de R$ 15,000 permitido'
        return false
      }
      return true
    },
    async handleAddCredit() {
      this.clearErrors()
      let validation = this.handleValidations()
      if (!validation) return
      this.loadings.saveCredits = true
      let response = await this.addCreditApi()
      if (!response?.data) return
      this.formattedTime = this.formatDate()
      if (this.payment.type === 'pix') {
        const stripe = window.Stripe(this.stripeKey)
        this.loadings.brazilPayments = true
        try {
          let ret = await stripe.confirmPixPayment(
            response.data.client_secret,
            {},
            { handleActions: false }
          )
          this.qrCodeSource =
            ret.paymentIntent.next_action.pix_display_qr_code.image_url_png
          this.paymentText =
            ret.paymentIntent.next_action.pix_display_qr_code.data
          setTimeout(() => {
            this.pendingPayment = true
          }, 1000)
          this.loadings.brazilPayments = false
        } catch (e) {
          this.handleFetchError(e)
        }
      }
      if (this.payment.type === 'boleto') {
        this.loadings.brazilPayments = true
        const stripe = window.Stripe(this.stripeKey)
        try {
          let ret = await stripe.confirmBoletoPayment(
            response.data.client_secret,
            {
              payment_method: {
                boleto: {
                  tax_id: this.$store.state.user.userPlanInfo?.taxId?.value,
                },
                billing_details: {
                  name: this.$store.state.user.userPlanInfo?.user?.name,
                  email: this.$store.state.user.userPlanInfo?.user?.email,
                  address: this.$store.state.user.userPlanInfo?.address,
                },
              },
            },
            { handleActions: false }
          )
          this.paymentText =
            ret.paymentIntent.next_action.boleto_display_details.number
          this.boletoPdfUrl =
            ret.paymentIntent.next_action.boleto_display_details.pdf
          setTimeout(() => {
            this.pendingPayment = true
          }, 1000)
          this.loadings.brazilPayments = false
        } catch (e) {
          this.handleFetchError(e)
        }
      }
      this.$root.$emit('updateCreditsList')
      this.loadings.saveCredits = false
    },
    async addCreditApi(cardId) {
      let data = {
        amount: this.creditValue,
        currency: 'brl',
        method: this.payment.type, // card, boleto, pix
      }
      if (this.payment.type === 'card') {
        if (this.radioCardValue === 'newCard' && !cardId) {
          await this.$refs.creditStripeCard.submit()
          return
        } else if (cardId) {
          data['payment_method_id'] = cardId
        } else {
          data['payment_method_id'] = this.radioCardValue
        }
      }
      try {
        const res = await creditsApi.addCredit(data)
        this.paymentDone = true
        return res
      } catch (e) {
        this.handleFetchError(e)
        console.error(e)
      }
    },
    async handleToken(token) {
      this.loadings.saveCredits = true
      try {
        await this.addCardToUser(token)
      } catch (error) {
        console.log(error)
      }
    },
    async addCardToUser(cardToken) {
      Object.keys(this.cardErrors).forEach((e) => (this.cardErrors[e] = false))
      try {
        let ret = await planApi.addCard(cardToken)
        let registeredCards = ret.data.filter(
          (source) => source.type === 'card'
        )
        const newCard = registeredCards.find((card) => {
          return !this.userCards.some((prevCard) => prevCard.id === card.id)
        })
        this.addCreditApi(newCard.id)
      } catch (e) {
        this.handleFetchError(e)
        switch (e.response.data.errMsg) {
          case 'card_declined':
            this.cardErrors.declined = true
            break
          case 'expired_card':
            this.cardErrors.expired = true
            break
          default:
            this.cardErrors.default = true
            break
        }
      }
    },
    handleFetchError(err) {
      this.loadings.saveCredits = false
      this.errors.shownErrMsg = i18n.t('message.errors.unexpectedError')
      let errString = ''
      if (
        err?.response?.data &&
        err?.response?.data?.errMsg &&
        err?.response?.data?.errCode
      ) {
        errString = err.response.data.errCode + err.response.data.errMsg
      }
      this.errors.tooltipErrMsg =
        err.msg ?? errString ?? err.response.data.message ?? err ?? 'Error'
      this.errors.fetchError = true
    },
    handleCopyPaymentCode() {
      const item = this.paymentText
      navigator.clipboard.writeText(`${item}`)
    },
    handleOpenBoletoPdf() {
      window.open(this.boletoPdfUrl, '_blank')
    },
    handleChangePaymentType(type) {
      this.payment.type = type
    },
    handleCreditsHistory() {
      this.$router.push({ name: 'Credits' }).catch(() => {})
      this.handleClose()
    },
    capitalizeFirstLetter(string) {
      if (!string) return
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    clearErrors() {
      Object.keys(this.errors).forEach((e) => {
        if (typeof this.errors[e] === 'string') {
          return (this.errors[e] = '')
        }
        this.errors[e] = false
      })
    },
    formatDate() {
      let timestamp = Date.now()
      const date = new Date(timestamp)
      // Get day, month and year
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear().toString()
      // Get hours and minutes
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      // Format the date string
      const formattedDate = `${day}/${month}/${year} às ${hours}h${minutes}`
      return formattedDate
    },
    handleClose() {
      this.open = false
    },
    initialState() {
      return {
        optionsValues: [20, 50],
        open: false,
        loadings: {
          saveCredits: false,
          getCardsLoading: false,
          brazilPayments: false,
        },
        creditValue: 20,
        payment: {
          type: 'card',
        },
        selectedCard: 1,
        userCards: [],
        defaultSource: null,
        cardsImages: {
          mastercard:
            'https://js.stripe.com/v3/fingerprinted/img/mastercard-4d8844094130711885b5e41b28c9848f.svg',
          visa: 'https://js.stripe.com/v3/fingerprinted/img/visa-729c05c240c4bdb47b03ac81d9945bfe.svg',
          elo: 'https://js.stripe.com/v3/fingerprinted/img/elo-efe873e884e6c9eb817f23a120caaa3e.svg',
          american_express:
            'https://js.stripe.com/v3/fingerprinted/img/elo-efe873e884e6c9eb817f23a120caaa3e.svg',
        },
        radioCardValue: null,
        currencyLocale: 'pt-BR',
        stripeKey: process.env.VUE_APP_STRIPE_API,
        stripeKeyUS: process.env.VUE_APP_STRIPE_API_US,
        pendingPayment: false,
        paymentDone: false,
        qrCodeSource: '',
        paymentText: '',
        boletoPdfUrl: '',
        errors: {
          fetchData: false,
          fetchError: false,
          shownErrMsg: 'Error',
          tooltipErrMsg: 'Error',
        },
        cardErrors: {
          declined: false,
          default: false,
          expired: false,
        },
        formattedTime: '',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.titleText {
  font-size: 18px;
  font-weight: 500;
  line-height: 120%;
  @media only screen and (max-width: 960px) {
    font-size: 14px !important;
  }
}
.mainText {
  font-size: 24px;
  font-weight: 500;
  line-height: 120%; /* 28.8px */
  @media only screen and (max-width: 960px) {
    font-size: 18px !important;
  }
}
.priceText {
  font-size: 14px;
  font-weight: 500;
  line-height: 150%; /* 21px */
}
.otherText {
  font-size: 16px;
  font-weight: 500;
  @media only screen and (max-width: 960px) {
    font-size: 13px !important;
  }
}

.optionsText {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 100%; /* 16px */
  font-style: normal;
  text-transform: none !important;
  letter-spacing: 0.5px;
  @media only screen and (max-width: 960px) {
    font-size: 13px !important;
  }
}
.paymentText {
  font-size: 16px;
  font-weight: 500;
  line-height: 150%; /* 24px */
  @media only screen and (max-width: 960px) {
    font-size: 13px !important;
  }
}
.cardText {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.02em;
  @media only screen and (max-width: 960px) {
    font-size: 13px !important;
  }
}
.quantityTextField {
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
}
.wrapText {
  word-break: break-word;
}

.dateText {
  font-size: 12px;
  font-weight: 400;
  line-height: 150%; /* 18px */
  @media only screen and (max-width: 960px) {
    font-size: 10px !important;
  }
}
.paymentCodeText {
  font-size: 14px;
  font-weight: 400px;
  @media only screen and (max-width: 960px) {
    font-size: 12px !important;
  }
}
</style>
